import { Box } from '@mui/material';
import { CONTAINER_CLASS, LabelField } from 'src/components/Fields/LabelField';
import {
  SIDE_PANEL_ROW_MIN_HEIGHT,
  SIDE_PANEL_ROW_PADDING_Y,
} from 'src/components/SidePanelRow';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { useConversationEntity } from './conversation-entity-context';

export const LabelsRow = (_props: SidePanelRowProps) => {
  const { conversation, canEdit } = useConversationEntity();
  const { groupRules } = useGroupRules();

  const canAccessToPrivateLabels = groupRules[UserGroupRules.AccessToPrivateLabels];

  return (
    <Box className={CONTAINER_CLASS}>
      <LabelField
        entityId={conversation.conversationId}
        entityName="Conversation"
        partnerId={conversation.partnerId}
        labelAssignments={conversation.labelAssignments}
        isEditable={canEdit}
        minHeight={SIDE_PANEL_ROW_MIN_HEIGHT}
        paddingBlock={SIDE_PANEL_ROW_PADDING_Y}
        canAccessToPrivateLabels={canAccessToPrivateLabels as boolean}
      />
    </Box>
  );
};
